import React from "react";
import classnames from "classnames";

class SidebarButton extends React.Component {
  constructor(props){
    super(props);
    this.clickHandler = this.clickHandler.bind(this);
  }
  
  clickHandler(e){
    e.preventDefault();
    this.props.onClick(e);
  }
  
  render() {
    const { active, iconClass, iconStyle, iconText, expanded, label, theme, title, styleOverride } = this.props;
    const btnClass = classnames({
      "btn": true,
      "btn-lg": true,
      "btn-block": true,
      'btn-default': true,
      "vertical-toolbar-button": true,
      "active": active
    })
    const txtClass = classnames({
      "overflow-ellipsis": true,
      "hidden": !iconText
    })
    const inlineClass = classnames({
      "icon-inline": expanded,
      "hidden": !!iconText
    });
    const labelClass = classnames({
      "hidden": !expanded
    });
    
    const style = Object.assign({textAlign: 'left'}, styleOverride);
    return (
      <div
        className={ btnClass + " " + theme }
        onClick={this.clickHandler}
        style={style}
        title={title}
      >
        <div style={{display:'flex', flexDirection:'row'}}>
          <i className={iconClass + " " + inlineClass} style={iconStyle} />
          <span className={txtClass}>{iconText}</span>
          <span className={labelClass}>{label}</span>
        </div>
               
      </div>
    );
  }
}

export default SidebarButton;
